module.exports = __webpack_public_path__ + "img/maintenance-4.cdef6f33.png";